// Tiny inline-SVG sparkline. No dependencies. Works inside the admin grid.
export default function Sparkline({ data = [], height = 56, stroke = "#E0761F", fill = "rgba(224,118,31,0.16)" }) {
  if (!data || data.length === 0) {
    return <div className="text-xs text-ink2">No data</div>;
  }
  const values = data.map((d) => Number(d.count) || 0);
  const max = Math.max(1, ...values);
  const w = 100;
  const h = 100;
  const stepX = w / Math.max(1, data.length - 1);
  const points = values.map((v, i) => {
    const x = i * stepX;
    const y = h - (v / max) * h;
    return [x, y];
  });
  const path = points.map(([x, y], i) => (i === 0 ? `M${x},${y}` : `L${x},${y}`)).join(" ");
  const area = `${path} L${w},${h} L0,${h} Z`;
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      style={{ width: "100%", height, display: "block" }}
      aria-hidden="true"
    >
      <path d={area} fill={fill} />
      <path d={path} fill="none" stroke={stroke} strokeWidth="1.5" vectorEffect="non-scaling-stroke" strokeLinejoin="round" strokeLinecap="round" />
      {points.length > 0 && (
        <circle cx={points[points.length - 1][0]} cy={points[points.length - 1][1]} r="1.5" fill={stroke} />
      )}
    </svg>
  );
}
